<div class="login-container" *ngIf="!loading">
    <div class="login-content">
        <div class="login-card-wrapper">
            <div class="login-logo-section">
                <img src="/assets/img/arl-logo-transparent.png" alt="ARL Logo" class="login-logo">
                <h1 class="portal-name">ARL PORTAL</h1>
                <p class="portal-subtitle">Advanced Industrial Services</p>
            </div>

            <form [formGroup]="loginForm" (ngSubmit)="login()" class="login-form">
                <div class="login-card" *ngIf="!showForgotPassword">
                    <div class="card-header-modern">
                        <h2>Client Login</h2>
                        <p>Authorized personnel only</p>
                    </div>

                    <div class="form-group-modern">
                        <label for="email">User Email</label>
                        <div class="input-with-icon">
                            <i class="material-icons">person_outline</i>
                            <input type="email" id="email" placeholder="Enter your email" formControlName="email">
                        </div>
                        <mat-error *ngIf="
                            (loginForm.get('email').dirty ||
                            loginForm.get('email').touched) &&
                            loginForm.get('email').hasError('required')
                        ">
                            Email is required
                        </mat-error>
                        <mat-error *ngIf="
                            (loginForm.get('email').dirty ||
                            loginForm.get('email').touched) &&
                            loginForm.get('email').hasError('email')
                        ">
                            Please enter a valid email address
                        </mat-error>
                        <mat-error *ngIf="
                            (loginForm.get('email').dirty ||
                            loginForm.get('email').touched) &&
                            loginForm.get('email').hasError('incorrect')
                        ">
                            Invalid email address
                        </mat-error>
                    </div>

                    <div class="form-group-modern">
                        <label for="password">Password</label>
                        <div class="input-with-icon">
                            <i class="material-icons">lock_open</i>
                            <input [type]="showPassword ? 'text' : 'password'" id="password" placeholder="••••••••" formControlName="password">
                            <button
                                type="button"
                                class="password-visibility-toggle"
                                (click)="showPassword = !showPassword"
                                [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
                                [attr.aria-pressed]="showPassword">
                                <i class="material-icons">{{ showPassword ? 'visibility_off' : 'visibility' }}</i>
                            </button>
                        </div>
                        <mat-error *ngIf="
                            (loginForm.get('password').dirty ||
                            loginForm.get('password').touched) &&
                            loginForm.get('password').hasError('required')
                        ">
                            Password is required
                        </mat-error>
                        <mat-error *ngIf="
                            loginForm.get('password').hasError('invalidCredentials')
                        ">
                            {{ loginErrorMessage }}
                        </mat-error>
                    </div>

                    <button type="submit" class="btn-login">
                        <span>AUTHENTICATE</span>
                        <i class="material-icons">verified_user</i>
                    </button>

                    <div class="forgot-password-link">
                        <button type="button" class="btn-forgot" (click)="toggleForgotPassword()">Forgot Password?</button>
                    </div>

                    <div class="login-extra" *ngIf="!(sharedService.isOnline$ | async)">
                        <button type="button" class="btn-offline" (click)="navigateToDraftReport()">
                            <i class="material-icons">wifi_off</i>
                            WORKING OFFLINE
                        </button>
                    </div>
                </div>

                <div class="login-card" *ngIf="showForgotPassword">
                    <div class="card-header-modern">
                        <h2>Reset Password</h2>
                        <p>Enter your email to receive a new password</p>
                    </div>

                    <div class="form-group-modern">
                        <label for="forgot-email">User Email</label>
                        <div class="input-with-icon">
                            <i class="material-icons">email</i>
                            <input type="email" id="forgot-email" placeholder="Enter your email" [(ngModel)]="forgotEmail" [ngModelOptions]="{standalone: true}">
                        </div>
                    </div>

                    <button type="button" class="btn-login" (click)="submitForgotPassword()" [disabled]="forgotLoading">
                        <span>{{ forgotLoading ? 'SENDING...' : 'SEND NEW PASSWORD' }}</span>
                        <i class="material-icons">{{ forgotLoading ? 'hourglass_empty' : 'send' }}</i>
                    </button>

                    <div class="forgot-password-link">
                        <button type="button" class="btn-forgot" (click)="toggleForgotPassword()">
                            <i class="material-icons" style="font-size:14px;vertical-align:middle;">arrow_back</i>
                            Back to Login
                        </button>
                    </div>
                </div>
            </form>

            <div class="login-footer">
                <p>PROTECTED SYSTEM &copy; {{ 2026 }} ARL Laboratory Services. V{{ version }}</p>
            </div>
        </div>
    </div>
</div>

<div class="loader-container" *ngIf="loading">
    <div class="loader-modern"></div>
    <p>Authenticating Session...</p>
</div>
